import { Component, Inject, Input, SkipSelf } from "@angular/core";
import { CommonFormManagerDirective } from "../../form-manager.directive";
import { VIDEO_PROFILE_TEMPLATES, videoProfilePresetProvider } from "./templates";

@Component({
    selector: "video-profiles",
    templateUrl: "./video-profiles.component.html",
    providers: [videoProfilePresetProvider],
})
export class VideoProfilePresetterComponent {
    @Input() public fieldProp = "videoProfile";
    @Input() public videoProfileId: number;
    public selectedPreset: { name?: string } = {};

    constructor(
        @SkipSelf() public formManager: CommonFormManagerDirective,
        @Inject(VIDEO_PROFILE_TEMPLATES) public templates,
    ) { }

    public get dynamicallyBuiltTemplates() {
        return this.templates.map((template) => {
            template.data.id = this.videoProfileId;
            return template;
        });
    }
}
